import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { getPersonality } from "../../redux/actions/appActions";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PERSONALITY_PROFILER } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import { Facebook, InsertLink, Instagram, Twitter } from "@mui/icons-material";

const Connector = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const personality = useSelector((state: any) => state.app.personality);

  useEffect(() => {
    dispatch(getPersonality());
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#756DE9",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        color: "#ffffff",
        fontFamily: "'Poppins', sans-serif",
        overflow: "hidden", // Hide overflow to prevent scrolling
        boxSizing: "border-box",
      }}
    >
      {personality?.map((el: any, idx: number) => {
        return (
          <React.Fragment key={idx}>
            <Box style={{ backgroundColor: "#fff", padding: "20px", textAlign: "center", borderRadius: "10px" }}>
              <img src={el?.imagePath} alt="" height={200} />
              <Typography
                variant="h6"
                sx={{ fontWeight: "500", fontSize: "18px", color: "#1F2235", textAlign: "center" }}
                m={2}
              >
                You are
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "30px",
                  color: "#1F2235",
                  textAlign: "center",
                }}
              >
                {el?.displayPersonalityType}
              </Typography>

              {el?.typeDescriptors?.split("\n").map((detail: string, index: number) => (
                <Typography
                  key={index}
                  variant="h6"
                  style={{ textAlign: "center", fontSize: "14px", fontWeight: "400", color: "#777777" }}
                >
                  {detail}
                </Typography>
              ))}
            </Box>
          </React.Fragment>
        );
      })}

      <Typography
        variant="h6"
        style={{ textAlign: "center", fontSize: "16px", fontWeight: "400", color: "#ffffff", marginTop: "20px" }}
      >
        Flaunt it with your friends!
      </Typography>

      <Stack direction="row" spacing={2} mt={3}>
        <Box
          onClick={() => window.open("https://facebook.com", "_blank")}
          sx={{ backgroundColor: "#645CDB", padding: "15px 15px 10px 15px", borderRadius: "100%" }}
        >
          <Facebook />
        </Box>
        <Box
          onClick={() => window.open("https://x.com", "_blank")}
          sx={{ backgroundColor: "#645CDB", padding: "15px 15px 10px 15px", borderRadius: "100px" }}
        >
          <Twitter />
        </Box>
        <Box
          onClick={() => window.open("https://instagram.com", "_blank")}
          sx={{ backgroundColor: "#645CDB", padding: "15px 15px 10px 15px", borderRadius: "100px" }}
        >
          <Instagram />
        </Box>
        <Box
          onClick={() => window.open("https://linkedin.com", "_blank")}
          sx={{ backgroundColor: "#645CDB", padding: "15px 15px 10px 15px", borderRadius: "100px" }}
        >
          <InsertLink />
        </Box>
      </Stack>

      <Typography
        variant="h6"
        style={{ textAlign: "center", fontSize: "16px", fontWeight: "400", color: "#ffffff", marginTop: "20px" }}
        onClick={() => navigate(ROUTE_PERSONALITY_PROFILER)}
      >
        SKIP
      </Typography>
    </Box>
  );
};

export default Connector;
